module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M25,27A10,10,0,1,1,35,17,10,10,0,0,1,25,27ZM25,8.9A8.1,8.1,0,1,0,33.1,17,8.1,8.1,0,0,0,25,8.9Z",
      "fill": _vm.color
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,1.9A23.09,23.09,0,0,1,43.58,38.71a8.59,8.59,0,0,0-1.84-3.84C41.69,34.81,36.16,29,25,29S8.31,34.81,8.26,34.87a8.59,8.59,0,0,0-1.84,3.84A23.09,23.09,0,0,1,25,1.9Zm0,46.2A23,23,0,0,1,8.09,40.71a8.34,8.34,0,0,1,1.63-4.48C11.07,34.78,16.45,31,25,31s13.93,3.78,15.28,5.23a8.34,8.34,0,0,1,1.63,4.48A23,23,0,0,1,25,48.1Z",
      "fill": _vm.color
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe64bb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/LinkToUserIcon.vue
// module id = 3106
// module chunks = 0